/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Input} from '@angular/core';
import template from './order-item-page.component.html';

import {AdminResourceItemPageBase} from '../common/controller/admin-resource-item-page-base';

@Component({
  standalone: false,
  selector: 'adn-order-item-page',
  template
})
export class OrderItemPageComponent extends AdminResourceItemPageBase {
  @Input() readOnly: boolean;

  constructor(cdr: ChangeDetectorRef) {
    super(cdr);
  }
}
